export interface UsageSummaryFailureState {
  hidden: boolean;
  clearSummary: boolean;
  error: string | null;
}

export function resolveUsageSummaryFailure(
  status: number | undefined,
  isParsleeStaff: boolean
): UsageSummaryFailureState {
  if (!isParsleeStaff) {
    return {
      hidden: true,
      clearSummary: true,
      error: null,
    };
  }

  return {
    hidden: false,
    clearSummary: false,
    error:
      status === 403
        ? 'Onboarding and usage are temporarily unavailable for this staff session. Retry once the API recovers.'
        : 'Failed to load onboarding and usage',
  };
}
